
fun main() {
    setupStimulus()
    setupScrollRestoration()
}

private fun setupScrollRestoration() {
    js(
        """
        (function() {
            if (window.__holidayplannerScrollRestoration) return;
            window.__holidayplannerScrollRestoration = true;

            var storageKey = "holidayplanner:scroll-positions";
            var shouldRestore = false;
            var scrollTimer = 0;

            var keyFor = function(url) {
                if (url === undefined) url = window.location.href;
                var parsed = new URL(url, window.location.href);
                return parsed.pathname + parsed.search;
            };

            var readPositions = function() {
                try {
                    return JSON.parse(sessionStorage.getItem(storageKey) || "{}");
                } catch (_) {
                    return {};
                }
            };

            var writePositions = function(positions) {
                try {
                    sessionStorage.setItem(storageKey, JSON.stringify(positions));
                } catch (_) {
                }
            };

            var savePosition = function(url) {
                if (url === undefined) url = window.location.href;
                var positions = readPositions();
                positions[keyFor(url)] = { x: window.scrollX, y: window.scrollY };
                writePositions(positions);
            };

            var restorePosition = function(url) {
                if (url === undefined) url = window.location.href;
                var position = readPositions()[keyFor(url)];
                if (!position) return;

                var attempts = 0;
                var apply = function() {
                    var maxY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
                    var y = Math.min(position.y || 0, maxY);
                    window.scrollTo(position.x || 0, y);

                    attempts += 1;
                    if (attempts < 12 && Math.abs(window.scrollY - y) > 2) {
                        window.setTimeout(apply, 50);
                    }
                };

                window.requestAnimationFrame(function() { window.requestAnimationFrame(apply); });
            };

            window.addEventListener("scroll", function() {
                window.clearTimeout(scrollTimer);
                scrollTimer = window.setTimeout(savePosition, 100);
            }, { passive: true });

            window.addEventListener("pagehide", function() { savePosition(); });
            window.addEventListener("beforeunload", function() { savePosition(); });
            window.addEventListener("popstate", function() {
                shouldRestore = true;
            });

            document.addEventListener("click", function(event) {
                var link = event.target.closest && event.target.closest("a[data-restore-scroll]");
                if (link) shouldRestore = true;
            });

            document.addEventListener("turbo:before-visit", function() { savePosition(); });
            document.addEventListener("turbo:load", function(event) {
                var direction = document.documentElement.getAttribute("data-turbo-visit-direction");
                if (!shouldRestore && direction !== "back" && direction !== "forward") return;

                shouldRestore = false;
                restorePosition(event.detail && event.detail.url ? event.detail.url : window.location.href);
            });
        })();
        """
    )
}
